import script from "./SupportPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportPanel.vue?vue&type=script&setup=true&lang=js"

import "./SupportPanel.vue?vue&type=style&index=0&id=5bfd9864&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bfd9864"]])

export default __exports__